import { createSlice } from '@reduxjs/toolkit'

export const selectedBuildingSlice = createSlice({
    name: 'selectedBuilding',
    initialState: {},
    reducers: {
        setSelectedBuilding: (state, action) => {
            return action.payload
        }
    }
})

export const { setSelectedBuilding } = selectedBuildingSlice.actions

export const getSelectedBuilding = (state) => state?.selectedBuilding

export default selectedBuildingSlice.reducer